import React, { useState } from "react";
import { FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import RevealOnScroll from "./RevealOnScroll";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    message: ""
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setStatus("Sending...");

//   const formBody = new URLSearchParams();
//   formBody.append("name", formData.name);
//   formBody.append("phone", formData.phone);
//   formBody.append("message", formData.message);

//   try {
//     await fetch("https://script.google.com/macros/s/AKfycby-2emH6v0yWdu7DxHO5qBNE8ZVMgHHlgaW3moCSwkPuAA-2SReE6c5ivnSbgHBwfDS/exec", {
//       method: "POST",
//       mode: "no-cors",
//       body: formBody
//     });

//     setStatus("Message sent successfully!");
//     setFormData({ name: "", phone: "", message: "" });

//   } catch (error) {
//     console.error(error);
//     setStatus("Failed to send message.");
//   }
// };

const WEB_APP_URL = "https://script.google.com/macros/s/AKfycbwyBKXTJAGLUeC2krZznPCqfg1pUMC1ovlWXiz91SUABYK2bCW27KNJ5Q0NVP2r6cgx/exec";
const handleSubmit = (e) => {
  e.preventDefault();
  setStatus("Sending...");

  const formBody =
    "name=" + encodeURIComponent(formData.name) +
    "&phone=" + encodeURIComponent(formData.phone) +
    "&message=" + encodeURIComponent(formData.message);

  fetch(WEB_APP_URL, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: formBody
  })
    .then(() => {
      setStatus("Message sent successfully!");
      setFormData({ name: "", phone: "", message: "" });
    })
    .catch(() => {
      setStatus("Failed to send message.");
    });
};
  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <RevealOnScroll>
          <h2>Get In Touch</h2>
          <p className="contact-subtitle">
            Need bulk stone supply? Contact us today.
          </p>
        </RevealOnScroll>

        <RevealOnScroll>
          <div className="contact-content">
            <div className="contact-form">
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                />

                <input
                  type="tel"
                  name="phone"
                  placeholder="Your Contact Number"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                />

                <textarea
                  rows="6"
                  name="message"
                  placeholder="Your Requirement"
                  required
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>

                <button type="submit" className="submit-button">
                  Send Inquiry
                </button>

                {status && <p className="form-status">{status}</p>}
              </form>
            </div>

            <div className="contact-info">
              <h4>Contact Information</h4>
                <p>
                  <FaMapMarkerAlt /> Ranchi Road near Heritage International School, Chianki, Palamu, Jharkhand - 822102
                </p>
                <p>
                  <FaPhone /> <a href="tel:+917979744685">+91 79797 44685</a>
                </p>
                <p>
                  <FaPhone /> <a href="tel:+916200110597">+91 62001 10597</a>
                </p>
                <p>
                  <FaPhone /> <a href="tel:+917488951309">+91 74889 51309</a>
                </p>

              <h4>Business Hours</h4>
              <p>Monday - Sunday: 8:00 AM - 6:00 PM</p>
              {/* <p>Sunday: Closed</p> */}
            </div>
          </div>
        </RevealOnScroll>
      </div>
    </section>
  );
};

export default Contact;